import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: {},
  danger: {
    fill: theme.colors['palette-red']
  },
  good: {
    fill: theme.colors['palette-green']
  },
  warning: {
    fill: theme.colors['palette-gold']
  }
}));

const DataChartStatusIcon = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    status = 'good',
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const classNameRoot = clsx(classes.root, classNameProp);
  const classNameSymbol = classes[status];

  const getPaths = () => {
    if (status === 'good') {
      return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M21 .59A2 2 0 0019.59 0H8a2 2 0 00-2 2v7.28a.26.26 0 00.24.25c.37 0 1 0 1.49.08A.25.25 0 008 9.36V2.5a.5.5 0 01.5-.5h10.88a.47.47 0 01.35.15l2.12 2.12a.47.47 0 01.15.35V18a.5.5 0 01-.5.5h-6.86a.25.25 0 00-.24.21 8.893 8.893 0 01-.4 1.46.24.24 0 00.23.33H22a2 2 0 002-2V4.41A2 2 0 0023.41 3L21 .59z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12.5 11.8l1.44-2a.24.24 0 01.33-.07l1.51.9a1 1 0 001.22-.18l.1-.12 2.69-3.74a.999.999 0 10-1.62-1.16l-2 2.8a.25.25 0 01-.33.06l-1.52-.9a1 1 0 00-1.32.28l-2 2.88a.24.24 0 00.07.34c.402.277.777.592 1.12.94a.25.25 0 00.31-.03z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        className: classNameSymbol,
        d: "M6.5 24A6.5 6.5 0 100 17.5 6.51 6.51 0 006.5 24zm-3.39-6.32a.74.74 0 011.06 0L5.47 19a.239.239 0 00.287.064A.239.239 0 005.84 19l2.73-3.7a.754.754 0 011.2.91l-2.9 3.87a1.5 1.5 0 01-2.26.16l-1.5-1.5a.74.74 0 010-1.06z"
      }));
    }

    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      d: "M12.29 12.09l1.64-2.32a.25.25 0 01.34-.07l1.5.9a1 1 0 001.23-.15l.1-.12 2.69-3.74a1 1 0 10-1.63-1.16l-2 2.8a.25.25 0 01-.33.06l-1.52-.9a1 1 0 00-1.31.28l-2.31 3.26a1.001 1.001 0 00.24 1.4 1 1 0 001.36-.24z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M24 18.5V4.41A2 2 0 0023.41 3L21 .59A2 2 0 0019.58 0H8a2 2 0 00-2 2v7.82a.25.25 0 00.23.25c.489.027.974.097 1.45.21a.24.24 0 00.32-.23V2.5a.5.5 0 01.5-.5h10.88a.47.47 0 01.35.15l2.12 2.12a.47.47 0 01.15.35V18a.5.5 0 01-.5.5h-8.34a.25.25 0 00-.22.37l.78 1.5a.25.25 0 00.22.13H22a2 2 0 002-2z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      className: classNameSymbol,
      d: "M6.5 11.5a1.43 1.43 0 00-1.28.77L.16 21.9A1.44 1.44 0 001.44 24h10.12a1.43 1.43 0 001.28-2.09l-5.06-9.64a1.43 1.43 0 00-1.28-.77zM5.75 16a.75.75 0 011.5 0v3a.75.75 0 11-1.5 0v-3zm.75 6.25a1 1 0 110-2 1 1 0 010 2z"
    }));
  };

  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: classNameRoot
  }, rest), getPaths());
};

export default DataChartStatusIcon;